export type ServicesTypeDTO = 'rest' | 'websocket';

export class Services {
  private _name: string = null;
  private _service: any = null;
  private _isInstantiated: boolean = false;
  private _type: ServicesTypeDTO = 'rest';

  public constructor(name: string, service: any, isInstancied: boolean = false) {
    this._name = name;
    this._service = service;
    this._isInstantiated = isInstancied;
  }

  public get(...params) {
    if (!this.isInstantiated()) {
      this.instantiate(...params);
    }

    return this._service;
  }

  public get name() {
    return this._name;
  }

  public isInstantiated() {
    return this._isInstantiated;
  }

  public instantiate(...params) {
    if (this._isInstantiated === true) {
      return this.get();
    }

    this._service = this._service(...params);
    this._isInstantiated = true;

    return this.get();
  }

  public set type(type: ServicesTypeDTO) {
    this._type = type;
  }

  public get type() {
    return this._type;
  }
}

export class ServicesRegistry {
  private static _inst: ServicesRegistry = null;
  private _registry: Map<string, Services> = new Map();

  private constructor() {}

  public static getInstance() {
    if (!ServicesRegistry._inst) {
      ServicesRegistry._inst = new ServicesRegistry();
    }

    return ServicesRegistry._inst;
  }

  public add(name, service: any, isInstantiated: boolean = false) {
    this._registry.set(name, new Services(name, service, isInstantiated));
  }

  public getAllUninstantiatedServicesNames(type: ServicesTypeDTO = 'rest'): string[] {
    return [...this._registry.values()].reduce((acc, service) => {
      if (!service.isInstantiated() && service.type === type) {
        acc.push(service.name);
      }

      return acc;
    }, [] as string[]);
  }

  public getAllInstantiatedServicesNames(type: ServicesTypeDTO = 'rest'): string[] {
    return [...this._registry.values()].reduce((acc, service) => {
      if (service.isInstantiated() && service.type === type) {
        acc.push(service.name);
      }

      return acc;
    }, [] as string[]);
  }

  public setType(name: string, type: ServicesTypeDTO) {
    const service = this._registry.get(name);
    if (!service) return null;

    return service.type = type;
  }

  public get(name: string, ...params) {
    const service = this._registry.get(name);
    if (!service) return null;

    return service.get(...params);
  }

  public has(name: string) {
    return this._registry.has(name);
  }
}
